import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import ar from './ar.json';
import en from './en.json';

const applyDocumentDirection = (lang: string): void => {
  const dir = lang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('lang', lang);
  document.documentElement.setAttribute('dir', dir);
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    fallbackLng: 'ar',
    defaultNS: 'translation',
    supportedLngs: ['ar', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })
  .then(() => {
    const lang = i18n.resolvedLanguage ?? i18n.language ?? 'ar';
    applyDocumentDirection(lang.startsWith('en') ? 'en' : 'ar');
  });

i18n.on('languageChanged', (lang) => {
  applyDocumentDirection(lang.startsWith('en') ? 'en' : 'ar');
});

export { applyDocumentDirection };
export default i18n;
